import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory();

/**
 * ログファイルを取得する用
 */
export const setLogFile = actionCreator<{
	data: string;
}>('SET_SEARCH_QUICK_MODE_ORG_USER_REGISTER_LOG');



// WEBPACK FOOTER //
// ./src/actions/quickModeOrgUserRegisterLogFile.ts